/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { User } from './User';
const AssignmentPeerFeedbackConnectionParser = 
/* #__PURE__ */ parsers.object([['subject', User], ['peer', User]]);
export class AssignmentPeerFeedbackConnection extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AssignmentPeerFeedbackConnectionParser.decode(input).map(res => new AssignmentPeerFeedbackConnection(res));
    }
    static unsafeDecode(input) {
        return AssignmentPeerFeedbackConnection.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssignmentPeerFeedbackConnectionParser.encode(data);
    }
    static schema() {
        return AssignmentPeerFeedbackConnectionParser.schema();
    }
}
